// src/components/NavBarMobile.jsx
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { translations } from "../api/translations";
import { Link as RouterLink } from "react-router-dom";
import { useContext, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";

export default function NavBarMobile() {
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);
  const cycleLanguage = () => {
    const supported = Object.keys(translations || { en: {}, fr: {} });
    const idx = supported.indexOf(language);
    const next = supported[(idx + 1) % supported.length];
    setLanguage(next);
  };

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: "background.paper",
          color: "text.primary",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Toolbar sx={{ minHeight: 56 }}>
          <IconButton edge="start" onClick={() => setOpen(true)} sx={{ mr: 1 }}>
            <MenuIcon />
          </IconButton>
          <Typography
            component={RouterLink}
            to="/"
            variant="h6"
            sx={{
              textDecoration: "none",
              color: "inherit",
              fontWeight: 700,
              flexGrow: 1,
            }}
          >
            {translate("Brand")}
          </Typography>
          <Button onClick={cycleLanguage} size="small" variant="outlined" sx={{ mr: 1, minWidth: 34, width: 34, height: 34, p: 0, borderRadius: "50%", fontSize: 11, fontWeight: 700 }} title={`Langue: ${language?.toUpperCase()}`}>
            {String(language || "en").toUpperCase()}
          </Button>
          {currentUser ? (
            <Button
              component={RouterLink}
              to="/app"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              {translate("MyTickets")}
            </Button>
          ) : (
            <Button
              component={RouterLink}
              to="/login"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              {translate("SignIn")}
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Drawer open={open} onClose={close} PaperProps={{ sx: { width: 260 } }}>
        <Box
          role="presentation"
          onClick={close}
          onKeyDown={close}
          sx={{ mt: 1 }}
        >
          <List>
            <ListItemButton component={RouterLink} to="/aboutus">
              <ListItemText primary={translate("NavOffer")} />
            </ListItemButton>
            <ListItemButton component={RouterLink} to="/pricing">
              <ListItemText primary={translate("Pricing")} />
            </ListItemButton>
            {!currentUser && (
              <ListItemButton component={RouterLink} to="/login">
                <ListItemText primary={translate("SignIn")} />
              </ListItemButton>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
}
